import React, { useEffect, useCallback, useMemo } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { makeStyles } from '@mui/styles';
import { Grid, Button, Divider } from '@mui/material';
import FileOpenIcon from '@mui/icons-material/FileOpen';
import ManageAccountsIcon from '@mui/icons-material/ManageAccounts';
import { Page, Header } from 'components';
import { DownloadFile } from 'actions/sessionActions.js';
import SpeedDial from '@mui/material/SpeedDial';
import IosShareIcon from '@mui/icons-material/IosShare';
import SpeedDialIcon from '@mui/material/SpeedDialIcon';
import SpeedDialAction from '@mui/material/SpeedDialAction';
import SiteOptDatatable from './components/SiteOptDatatable';
import SiteOptDialog from './components/SiteOptDialog/SiteOptDialog';
import SiteOptDeleteDialog from './components/SiteOptDialog/SiteOptDeleteDialog';
import SiteOptAddFileDialog from './components/SiteOptDialog/components/components/SiteOptAddFileDialog';
import SiteOptDeleteFileDialog from './components/SiteOptDialog/components/components/SiteOptDeleteFileDialog';
import {
	SetFormState, GetSitesOptIncidents, ToggleSiteOptDialog,
	ToggleDeleteSiteOptDialog, ExportSitesOptIncidents,
	GetDriveTestsCities, GetDriveTestsDrives, SetSelectedDates, SetSelectedFailures,
	ToggleAttachFileSiteOptDialog, ToggleRemoveFileSiteOptDialog
} from '../actions/SiteOptActions';

const useStyles = makeStyles((theme) => ({
	root: {
		padding: theme.spacing(3),
	},
	container: {
		marginTop: theme.spacing(1),
	},
	tabs: {
		marginTop: theme.spacing(1),
	},
	content: {
		marginTop: theme.spacing(1),
	},
}));

const SiteOptTracker = () => {
	const classes = useStyles();
	const dispatch = useDispatch();
	const setFormState = formState => dispatch(SetFormState(formState));
	const formState = useSelector((state) => state.siteOptReducer.formState);
	const userId = useSelector(state => state.session.user.id);
	const role = useSelector(state => state.session.user.role);
	const incidents = useSelector((state) => state.siteOptReducer.incidents);
	const SiteOptDialogVisibility = useSelector((state) => state.siteOptReducer.SiteOptDialogVisibility);
	const deleteSiteOptDialogVisibility = useSelector((state) => state.siteOptReducer.deleteSiteOptDialogVisibility);
	const attachFileSiteOptDialogVisibility = useSelector((state) => state.siteOptReducer.attachFileSiteOptDialogVisibility);
	const removeFileSiteOptDialogVisibility = useSelector((state) => state.siteOptReducer.removeFileSiteOptDialogVisibility);

	useEffect(() => {
		if (SiteOptDialogVisibility === false && deleteSiteOptDialogVisibility === false) {
			dispatch(GetSitesOptIncidents(userId, role));
		} else {
			// dispatch(GetDriveTestsCities());
			// dispatch(GetDriveTestsDrives());
		}
	}, [SiteOptDialogVisibility, deleteSiteOptDialogVisibility]);

	const _SiteOptDialogClose = (event, reason) => {
		if (reason !== 'backdropClick') {
			dispatch(ToggleSiteOptDialog(false));
		}
	};

	const _SiteOptDeleteDialogClose = () => {
		dispatch(ToggleDeleteSiteOptDialog(false));
	};

	const _attachFileSiteOptDialogClose = () => {
		dispatch(ToggleAttachFileSiteOptDialog(false));
	};

	const _removeFileSiteOptDialogClose = () => {
		dispatch(ToggleRemoveFileSiteOptDialog(false));
	};

	const _onCreateSiteIncidentClick = () => {
		dispatch(ToggleSiteOptDialog(true));
		setFormState({
			...formState,
			values: {
				...formState.values,
				cfnOwner: userId
			},
		});
		dispatch(SetSelectedDates([]));
		dispatch(SetSelectedFailures([]));
	};

	const _onExportIncidentsClick = () => {
		dispatch(ExportSitesOptIncidents(userId, role));
	};

	const actions = [
		{ icon: <FileOpenIcon />, name: 'Create Incident', id: 'createtIncident' },
		{ icon: <IosShareIcon />, name: 'Export Incidents', id: 'exportIncidents' },
	];

	const _handleSpeedDialClick = (action) => {
		if (action.id === 'createtIncident') {
			_onCreateSiteIncidentClick();
		} else if (action.id === 'exportIncidents') {
			dispatch(ExportSitesOptIncidents(userId, role));
		}
	};

	return (
		<Page className={classes.root} title="Tracker">
			<Header module="Modules" view="Site Optimizations" />
			<SpeedDial
				ariaLabel="SpeedDial"
				sx={{ position: 'absolute', bottom: 16, right: 16 }}
				icon={<SpeedDialIcon />}
			>
				{actions.map((action) => (
					<SpeedDialAction
						key={action.name}
						icon={action.icon}
						tooltipTitle={action.name}
						onClick={() => { _handleSpeedDialClick(action); }}
					/>
				))}
			</SpeedDial>
			{/* <Grid className={classes.container} container spacing={3}>
				<Grid item lg={12} xs={12}>
					<Button
						className={classes.agreeButton}
						color="primary"
						onClick={_onCreateSiteIncidentClick}
						variant="contained"
						size="small"
					>
						Create Incident
					</Button>
					<Button
						className={classes.agreeButton}
						// color="primary"
						onClick={_onExportIncidentsClick}
						variant="contained"
						size="small"
					>
						Export Incidents
					</Button>
				</Grid>
			</Grid> */}
			<Grid className={classes.container} container spacing={3}>
				<Grid item lg={12} xs={12}>
					<SiteOptDatatable className={classes.results} data={incidents} />
					{SiteOptDialogVisibility && (
						<SiteOptDialog
							onClose={_SiteOptDialogClose}
							open={SiteOptDialogVisibility}
						/>
					)}
					{deleteSiteOptDialogVisibility && (
						<SiteOptDeleteDialog
							onClose={_SiteOptDeleteDialogClose}
							open={deleteSiteOptDialogVisibility}
						/>
					)}
					{attachFileSiteOptDialogVisibility && (
						<SiteOptAddFileDialog
							onClose={_attachFileSiteOptDialogClose}
							open={attachFileSiteOptDialogVisibility}
						/>
					)}
					{removeFileSiteOptDialogVisibility && (
						<SiteOptDeleteFileDialog
							onClose={_removeFileSiteOptDialogClose}
							open={removeFileSiteOptDialogVisibility}
						/>
					)}
				</Grid>
			</Grid>
		</Page>

	);
};

export default SiteOptTracker;
